export default "__VITE_ASSET__e_9RbZGL__"